import { createMatchContext, createUiInteractionPrimaryEvent } from "./snowplowTracking";
import { trackCustomSnowplowEvent } from "./snowplowEventTrackers";

/**
 * Tracks a UI interaction event with match context
 * @param {object} params - Parameters for tracking
 * @param {object} params.mlsMatch - Match object containing match data
 * @param {string} params.element_name - Name or ID of the UI element (button/link)
 * @param {'click'|'tap'|'hover'|'scroll'|'swipe'|'drag'|'long_press'} params.interaction_type - Type of UI interaction
 * @param {string} [params.element_type] - Type of UI element (e.g., button, image, link, card)
 * @param {string} [params.element_position] - Position of the element in the UI
 */
export function trackMatchInteraction({
    mlsMatch = {},
    element_name,
    interaction_type,
    element_type,
    element_position
}) {
    const { environment, match_information = {}, home = {}, away = {} } = mlsMatch
    const matchContext = createMatchContext({
        match_id: match_information.match_id || mlsMatch.id,
        home_team: home?.team_name || mlsMatch.homeTeam?.name,
        away_team: away?.team_name || mlsMatch.awayTeam?.name,
        kickoff_time: match_information.kickoff_time || mlsMatch.matchDate,
        home_team_id: home?.team_id || mlsMatch.homeTeam?.id,
        away_team_id: away?.team_id || mlsMatch.awayTeam?.id,
        venue: environment.stadium_name || mlsMatch.stadium?.name,
        match_status: match_information.match_status,
    });

    const uiInteractionEvent = createUiInteractionPrimaryEvent({
        element_name,
        interaction_type,
        element_type,
        element_position
    });

    const contexts = matchContext ? [matchContext] : [];
    trackCustomSnowplowEvent(uiInteractionEvent, contexts);
}

export function trackMatchClick({
    mlsMatch,
    element_name,
    element_type,
    element_position
}) {
    const { match_information = {} } = mlsMatch || {};

    return trackMatchInteraction({
        mlsMatch,
        element_name: element_name || match_information?.match_id || match_information?.match_title,
        interaction_type: 'click',
        element_type,
        element_position
    });
}